var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSlideshareDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3394_11742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6638 12.0078C12.0075 12.0078 9.84345 14.0156 9.84345 16.5156C9.84345 18.9922 12.0075 21.0234 14.6638 21.0234C17.32 21.0234 19.4841 18.9922 19.4841 16.5156C19.4841 14.0156 17.32 12.0078 14.6638 12.0078ZM25.8669 12.0078C23.2106 12.0078 21.0466 14.0156 21.0466 16.5156C21.0466 18.9922 23.2106 21.0234 25.8669 21.0234C28.5466 21.0234 30.6872 18.9922 30.6872 16.5156C30.695 14.0156 28.5466 12.0078 25.8669 12.0078ZM38.1013 19.0391L37.6325 19.375V3.88281C37.6325 1.74219 36.0231 0 34.0388 0H5.98408C3.9997 0 2.39033 1.74219 2.39033 3.88281V19.375C2.23408 19.2656 2.05439 19.1484 1.89814 19.0391C0.718455 18.2109 -0.0627953 19.3516 0.648142 20.4219C2.07783 22.1875 4.79658 24.3516 8.95283 26.0469C4.55439 41.0234 19.6872 43.4141 19.445 35.7422C19.445 35.6875 19.4685 31.3203 19.4685 28.1953C19.8669 28.2812 20.2028 28.375 20.5388 28.4375C20.5388 31.5391 20.5622 35.6875 20.5622 35.7422C20.32 43.4219 35.4528 41.0312 31.0544 26.0547C35.2028 24.3594 37.9294 22.1953 39.3591 20.4297C40.07 19.3516 39.2888 18.2188 38.1013 19.0391ZM35.7185 20.5391C30.3356 23.4609 25.695 22.9688 23.1716 22.8594C21.32 22.7891 20.6247 23.5703 20.5388 24.8047C19.7341 24.2031 19.0856 23.5938 18.9528 23.4688C18.5544 23.0469 17.8825 22.8438 16.8356 22.8672C14.3591 22.9531 9.82783 23.4453 4.53877 20.6797V5.64844C4.53877 2.92188 5.23408 2.07812 7.71064 2.07812H32.531C34.8981 2.07812 35.7263 3.08594 35.7263 5.64844V20.5391H35.7185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3394_11742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSlideshareDark);
export default __webpack_public_path__ + "static/media/ic-slideshare-dark.9f149456693980d742f442a075ff49db.svg";
export { ForwardRef as ReactComponent };